export default __webpack_public_path__ + "static/dev_illustration-4f725928dfc51305b89d42116269dfa8.svg";